<template>
    <div class="HCxF">
        <atomic-search-interface class="container container-fluid research-hub"  fields-to-include='["summary", "researchfocus", "researchtype", "studyz32xstatus", "awardz32xtimelinez32xstartz32xdate", "awardz32xtimelinez32xendz32xdate","ResearchHubInstitutionNameWithState","ResearchHubInstitutionDetail"]'  :search-hub="searchHub" >
            <atomic-layout-section section="search">
                <div class="search-input-container">
                    <label class="search-label" for="search">Search</label>
                    <atomic-search-box clear-filters="true"  />
                </div>
            </atomic-layout-section>
            <hr class="research-hub-divider">
           <div class="row mb-4">
                <div class="col-lg-3">
                    <hcxf-research-facets></hcxf-research-facets>
                </div>
                <div class="col-lg-9">
                    <atomic-layout-section section="main">
                        <hcxf-research-status></hcxf-research-status>
                        <hcxf-research-search-results />
                        <coveoPagination></coveoPagination>
                    </atomic-layout-section>
                </div>
           </div>
        </atomic-search-interface>
    </div>
</template>

<script>
    import coveoPagination from './atomic-pagination.vue'

    export default {
        props: {
            accessToken: {
                type: String,
                required: true,
            },
            organizationId: {
                type: String,
                required: true,
            },
            searchHub: {
                type: String,
                required: true,
            },
            indexName: {
                type: String,
                required: true,
            },
            templateId: {
                type: String,
                required: true,
            },
            
        },
        methods: {
            async initInterface() {

                await customElements.whenDefined("atomic-search-interface");
                const searchInterface = document.querySelector("atomic-search-interface");

                await searchInterface.initialize({
                    accessToken: this.accessToken,
                    organizationId: this.organizationId,
                     preprocessRequest: (request, clientOrigin, metadata) => { 
       
                        const body = JSON.parse(request.body);
                        if (clientOrigin === 'searchApiFetch') {
                            body.aq ='(@source==(\"' + this.indexName + '\") ( @z95xtemplate=' + this.templateId + '))';
                            body.searchHub = this.searchHub;
                        }
                        
                        request.body = JSON.stringify(body);
                        return request;
                        },
                });
 
                const engine = searchInterface.engine;
                searchInterface.executeFirstSearch();

                engine.subscribe(()=>{
                    const searchBox = document.querySelector('atomic-search-box').shadowRoot;
                    if(searchBox.children[0] && searchBox.children[0].firstElementChild) {
                        const div = searchBox.children[0].firstElementChild
                        if (div) {
                            div.classList.add("w-full")
                        }  
                    }
                    if (engine.state.query.q) {
                        const clearButton = searchBox.querySelector('[part="clear-button"]');
                        if(clearButton) {
                            clearButton.addEventListener("click", async ()=> {
                                searchBox.querySelector('[part="submit-button"]').click()
                            })
                        }  
                    }         
                })
            }
        },
        mounted() {
            this.initInterface();
        },
        components: {
            coveoPagination: coveoPagination
        }
    }
</script>


// WEBPACK FOOTER //
// src/app/components/hcxf/hcxf-research-hub.vue